/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People2Icon24Solid = forwardRef('People2Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z" }),
        React.createElement("path", { d: "M21.124 10.5a3.25 3.25 0 1 1-6.498 0 3.25 3.25 0 0 1 6.498 0Z" }),
        React.createElement("path", { d: "M16 19.33C16 15.27 11.873 14 8.5 14S1 15.269 1 19.33c0 .922.728 1.67 1.626 1.67h11.747c.899 0 1.627-.748 1.627-1.67Z" }),
        React.createElement("path", { d: "M21.167 21h-3.875c.134-.306.208-.644.208-1v-1c0-1.46-.437-2.743-1.262-3.774a5.744 5.744 0 0 0-.108-.13c1.57-.225 3.317-.055 4.618.513C22.16 16.225 23 17.527 23 19.112 23 20.155 22.18 21 21.167 21Z" })));
});
